import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, Pill } from "@/components/perf";
import PlayerName from "@/components/PlayerName";
import { Trophy, Calendar, MapPin, Loader2, Medal } from "lucide-react";

export default function ChampionsWall() {
  const [wall, setWall] = useState(null);
  useEffect(() => {
    api.get("/champions/wall").then(({ data }) => setWall(data)).catch(() => setWall([]));
  }, []);

  return (
    <div className="relative" data-testid="champions-wall-page">
      <PageHeader kicker="Legends Live Here · Pickle Bullpen" title="Wall of Champions"
        subtitle="Every title ever won on our courts — enshrined in gold. Chase yours." />
      {!wall && <div className="flex items-center gap-2 text-zinc-500 text-sm mt-8"><Loader2 className="w-4 h-4 animate-spin" /> Polishing the gold…</div>}
      {wall?.length === 0 && (
        <div className="border border-pb-border bg-pb-surface p-10 text-center mt-8" data-testid="wall-empty">
          <Trophy className="w-10 h-10 text-yellow-400 mx-auto mb-3" />
          <div className="font-display font-black uppercase text-xl">The wall awaits its first legend</div>
          <div className="text-sm text-zinc-500 mt-1">Win a tournament and your name lives here forever.</div>
        </div>
      )}
      <div className="space-y-4 mt-8">
        {wall?.map((t) => (
          <div key={t.id} data-testid={`wall-tournament-${t.id}`}
            className="bg-pb-surface border border-yellow-500/30 p-5 relative overflow-hidden">
            <div className="absolute inset-y-0 left-0 w-1 bg-gradient-to-b from-yellow-300 via-yellow-500 to-amber-600" />
            <div className="flex flex-wrap items-center gap-3 mb-3">
              <div className="font-display font-black text-xl uppercase">{t.name}</div>
              <span className="text-xs text-zinc-500 flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> {t.date}</span>
              {t.location && <span className="text-xs text-zinc-500 flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {t.location}</span>}
            </div>
            <div className="grid sm:grid-cols-2 gap-3">
              {t.champions.map((c) => (
                <div key={c.label} data-testid={`wall-champ-${t.id}-${c.label}`}
                  className="border border-pb-border bg-pb-elevated/50 px-4 py-3">
                  <div className="text-[9px] uppercase tracking-[0.25em] text-zinc-500 mb-1">{c.label}</div>
                  <div className="flex items-center gap-2">
                    <Trophy className="w-5 h-5 text-yellow-400 fill-yellow-400 drop-shadow-[0_0_6px_rgba(250,204,21,0.7)] shrink-0" />
                    <PlayerName userId={c.champion_user_id} name={c.champion_name} className="font-bold text-yellow-300" />
                  </div>
                  {c.runner_up_name && (
                    <div className="flex items-center gap-2 mt-1 text-xs text-zinc-500">
                      <Medal className="w-3.5 h-3.5 text-zinc-400" /> Runner-up: {c.runner_up_name}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
